import moment from 'moment';

const currentTime = moment();

export const dayTime = (timestamp, format = 'HH:mm') => {
    return moment.unix(timestamp).format(format);
};

export const unixFormat = (timestamp, format = 'DD.MM.YYYY') => {
    if (!timestamp) return '';
    
    return moment.unix(timestamp).format(format);
};

export const isSameAs = (unixA, unixB, param = 'day') => {
    if (!unixA || !unixB) return false;
    
    return moment(moment.unix(unixA)).isSame(moment.unix(unixB), param);
};

export const isBetweenUnix = (controlUnix, beforeUnix, afterUnix) => {
    return moment(moment.unix(controlUnix)).isBetween(moment.unix(beforeUnix), moment.unix(afterUnix));
};

export const generateTimeIntervals = (timeStartUnix, timeEndUnix, intervalMinutes = 60, addHours = 1) => {
    const intervals = [];
    let current = moment.unix(timeStartUnix);
    const end = moment.unix(timeEndUnix).add(addHours, 'hours').unix();
    
    while (current.unix() <= end) {
        intervals.push(moment(current.clone()).unix());
        current.add(intervalMinutes, 'minutes');
    }

    return intervals;
};

export const generateRealIntervals = (timeStartUnix, timeEndUnix, intervalMinutes = 60) => {
    const intervals = [];
    let current = moment.unix(timeStartUnix);
    const end = moment.unix(timeEndUnix);
    
    while (current.unix() <= end.unix()) {
        if (!!intervals.length && current.unix() < intervals[0]) {
            current.add(intervalMinutes, 'minutes');

            continue;
        }

        intervals.push(moment(current.clone()).unix());

        if (current.unix() === timeStartUnix) {
            current = current.startOf('hour');
        }

        current.add(intervalMinutes, 'minutes');
    }

    if (intervals[intervals.length - 1] < end.unix()) {
        intervals.push(end.unix());
    }

    return intervals;
};

export const unixDiff = (unixStart, unixEnd, unit = 'minutes') => {
    if (!unit) return;
    const _unixStart = moment.unix(unixStart).startOf(unit.slice(0, -1));
    const _unixEnd = moment.unix(unixEnd).startOf(unit.slice(0, -1));
    return _unixEnd.diff(_unixStart, unit);
};

export const generateDateWithDay = (timestamp, locale) => {
    const date = moment.unix(timestamp).toDate();

    return new Intl.DateTimeFormat(locale, {
       day: 'numeric',
       month: 'long',
    }).format(date);
};

export const checkTimeDifference = (time, difference, unit = 'minutes') => {
    const messageTime = moment.unix(time);
    const timeDifference = currentTime.diff(messageTime, unit);

    return timeDifference <= difference;
};
